import InverterConnectedMessage from '../../InverterConnectedMessage';

interface ConnectedStepProps {
  onContinue: () => void;
}

const ConnectedStep = ({ onContinue }: ConnectedStepProps) => <InverterConnectedMessage onContinue={onContinue} />;

export default ConnectedStep;
